module.exports = __webpack_public_path__ + "static/cookie1-631307d3126db7c870a2529c7b495495.svg";